import { OrganizationUnitType } from '@inplay/models';
import { Organization, OrgUnit } from '../../../utils/helper.type';
import { OrgUnitPresentation } from '../orgUnitPresentation.interface';
import {
  OrganizationUnitKey,
  VenuesViewKebabOptions,
  VenuesViewTableHeaderKey,
} from '../../../pages/userManagement/venuesView/venuesView.type';
import { OptionWithLoading } from '../../../pages/userManagement/userManagement.type';
import { VenuesViewTableColumns } from '../orgUnitPresentationTypes';
import { getOrganizationUnitsByTypeAndParent } from '../../../pages/userManagement/venuesView/venuesViewHelper';

export class OrganizationPresentationStrategy
  implements OrgUnitPresentation<Organization>
{
  public unitTranslationKey = 'userManagement.organizations';
  public orgUnitType = OrganizationUnitType.ORGANIZATION;

  getTableData(
    allOrgUnits: OrgUnit[],
    parentOrgUnitId: string | null,
  ): Organization[] {
    if (parentOrgUnitId) {
      return getOrganizationUnitsByTypeAndParent(
        allOrgUnits,
        OrganizationUnitType.ORGANIZATION,
        parentOrgUnitId,
      ) as Organization[];
    }

    const organizations: Organization[] = allOrgUnits.filter(
      (orgUnit: OrgUnit) => orgUnit.type === OrganizationUnitType.ORGANIZATION,
    ) as Organization[];

    return organizations;
  }

  getTableColumns(): VenuesViewTableColumns[] {
    return [
      {
        header: VenuesViewTableHeaderKey.ORG_NAME,
        sortable: true,
        key: OrganizationUnitKey.NAME,
      },
      { header: VenuesViewTableHeaderKey.STATUS },
      { header: VenuesViewTableHeaderKey.ACTIVE_USERS },
      { header: VenuesViewTableHeaderKey.INACTIVE_USERS },
      { header: VenuesViewTableHeaderKey.SUB_ORGS },
      { header: VenuesViewTableHeaderKey.VENUE_BRANCHES },
      { header: VenuesViewTableHeaderKey.ADDED_BY },
    ];
  }

  getKebabOptions(): OptionWithLoading<VenuesViewKebabOptions>[] {
    return [
      {
        loading: false,
        label: VenuesViewKebabOptions.EDIT_ORG,
        value: VenuesViewKebabOptions.EDIT_ORG,
      },
    ];
  }
}
